import FormType from "../../Components/Form/FormType";

const FormOptions = {
  Fields: [
    {
      element: FormType.Input,
      required: true,
      label: "First Name",
      name: "firstname",
      placeholder: "Enter first name",
    },
    {
      element: FormType.Input,
      required: true,
      label: "Last Name",
      name: "lastname",
      placeholder: "Enter last name",
    },
    {
      element: FormType.Input,
      required: true,
      label: "Email",
      name: "email",
      type: "email",
      placeholder: "Enter email address",
    },
    {
      element: FormType.Input,
      required: true,
      label: "Phone Number",
      name: "phone",
      placeholder: "Enter phone number",
    },
  ],
  Buttons: [{ text: "Save", className: "Btn-Mid Active" }],
};

export default FormOptions;
